"use client";

import dynamic from "next/dynamic";
import BirthToolFormShell from "@/components/tool-shell/BirthToolFormShell";
import { CALCULATOR_FORM_COPY } from "@/components/calculator-form-copy";
import { useDeferredToolActivation } from "@/components/tool-shell/useDeferredToolActivation";

// Bundle-size discipline (2026-07-16 trim pass): the interactive island
// (BirthDetailsForm + PlaceAutocomplete + result stack) lives in
// ./AscendantCalculatorClient and loads via next/dynamic, sharing ONE copy of
// the form stack with the other deferred calculator islands. Static header and
// explanation belong to the server surface; only the form hydrates here.
// The shell reserves the swap height (rule 58).
// The pre-activation shell and the chunk-loading shell carry the island's
// own form props, so every frame before the island mounts reads the same
// words as the island (see BirthToolFormShell.parity.test.tsx).
const SHELL_PROPS = {
  en: {
    language: "en",
    submitLabel: CALCULATOR_FORM_COPY.ascendant.en.submit,
    requireBirthTime: true,
  },
  hi: {
    language: "hi",
    submitLabel: CALCULATOR_FORM_COPY.ascendant.hi.submit,
    requireBirthTime: true,
  },
} as const;

const ISLANDS = {
  en: dynamic(() => import("./AscendantCalculatorClient"), {
    ssr: false,
    loading: () => <BirthToolFormShell {...SHELL_PROPS.en} />,
  }),
  hi: dynamic(() => import("./AscendantCalculatorClient"), {
    ssr: false,
    loading: () => <BirthToolFormShell {...SHELL_PROPS.hi} />,
  }),
};

export default function DeferredAscendantCalculatorClient({
  language = "en",
}: {
  language?: "en" | "hi";
}) {
  const { ready, activate } = useDeferredToolActivation({ interactionOnly: true });
  const AscendantToolIslandPicked = ISLANDS[language];

  return ready ? (
    <AscendantToolIslandPicked language={language} />
  ) : (
    <BirthToolFormShell {...SHELL_PROPS[language]} onActivate={activate} />
  );
}
